import { render, staticRenderFns } from "./menu_edit.vue?vue&type=template&id=8f51da88&scoped=true&"
import script from "./menu_edit.vue?vue&type=script&lang=js&"
export * from "./menu_edit.vue?vue&type=script&lang=js&"
import style0 from "./menu_edit.vue?vue&type=style&index=0&id=8f51da88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f51da88",
  null
  
)

export default component.exports